import script from "./ReviewDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReviewDialog.vue?vue&type=script&setup=true&lang=ts"

import "./ReviewDialog.vue?vue&type=style&index=0&id=762ae8c9&lang=scss"

const __exports__ = script;

export default __exports__